import React, { useEffect, useState } from "react";
import {
  Breadcrumb,
  Row,
  Col,
  Card,
  Space,
  Button,
  Drawer,
  Descriptions,
  Anchor,
  Tag,
  Result,
} from "antd";
import { Table } from "ant-table-extensions";
import http from "../../../../helpers/http";
import helper from "../../../../helpers/helper";
import config from "../../../../config/config";
import "./style.css";
import { CSVLink } from "react-csv";
function Winners() {
  const [loading, setloading] = useState(false);
  const [drawerOpen, setdraweropen] = useState(false);
  const [datas, setDatas] = useState([]);
  const [data, setData] = useState({});
  const moduleNamePural = "Diwali Bonanza Weekly Winners";
  const base_url = config.api_url + "admin/leads/diwali-bonanza-2025/winners"; //without trailing slash
  const image_url = config.api_url + "public/uploads/diwali-bonanza-2025/"; //with trailing slash

  const { Link } = Anchor;

  const handleView = async (id) => {
    const { data } = await http.get(`${base_url}/${id}`);

    if (data) {
      console.log(data);
      setData(data);
      setdraweropen(true);
    }
  };

  const handleDrawerClose = () => {
    setData({});
    setdraweropen(false);
  };

  const fetchDatas = async () => {
    setloading(true);
    const data = await http.get(base_url);

    if (data) {
      setDatas(data.data);
    }
    setloading(false);
  };

  useEffect(() => {
    fetchDatas();
  }, []);

  const columns = [
    {
      title: "From",
      render: (text, record) => {
        return helper.UTCDate(record.from, "YYYY-MM-DD");
      },
      key: "from",
    },
    {
      title: "To",
      render: (text, record) => {
        return helper.UTCDate(record.to, "YYYY-MM-DD");
      },
      key: "to",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },

    {
      title: "Generated At",
      render: (text, record) => {
        return helper.UserDate(record.createdAt, "-04:00");
      },
      key: "createdAt",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Button
            onClick={() => {
              handleView(record._id);
            }}
          >
            View Winners
          </Button>
          <CSVLink
            data={record.winners}
            headers={headers}
            filename={`${helper.UTCDate(
              record.from,
              "YYYY-MM-DD"
            )} - ${helper.UTCDate(record.to, "YYYY-MM-DD")}.csv`}
          >
            Export
          </CSVLink>
        </Space>
      ),
    },
  ];

  const headers = [
    { label: "First Name", key: "user.first_name" },
    { label: "Last Name", key: "user.last_name" },
    { label: "Email Id", key: "user.email" },
    { label: "Country Code", key: "user.country_code" },
    { label: "phone", key: "user.phone" },
    { label: "gender", key: "user.gender" },
    { label: "age", key: "user.age" },
    { label: "country", key: "user.country" },
    { label: "state", key: "user.state" },
    { label: "city", key: "user.city" },
    { label: "zip code", key: "user.zip" },
    { label: "code", key: "user.coupon_code" },
    { label: "gift", key: "gift.label" },
  ];

  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>Leads</Breadcrumb.Item>
        <Breadcrumb.Item>{moduleNamePural}</Breadcrumb.Item>
      </Breadcrumb>

      <Row>
        <Col span={24}>
          <div className="site-card-border-less-wrapper">
            <Card title={moduleNamePural} bordered={false}>
              <Table
                rowKey={(record) => record._id}
                columns={columns}
                dataSource={datas}
                loading={loading}
                // exportableProps={{
                //   showColumnPicker: true,
                //   fields,
                //   fileName: moduleNamePural,
                // }}
                // searchable
              />
            </Card>

            <Drawer
              title="Winners"
              placement="right"
              onClose={handleDrawerClose}
              visible={drawerOpen}
              size="large"
            >
              {data?.winners?.length ? (
                data?.winners?.map((winner, i) => {
                  return (
                    <>
                      <Descriptions
                        bordered
                        column={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }}
                        title={`Winner ${i + 1}:`}
                        style={{ marginBottom: 20 }}
                      >
                        <Descriptions.Item label="Name">
                          {`${winner.user?.first_name}  ${winner.user?.last_name}`}
                        </Descriptions.Item>
                        <Descriptions.Item label="Email">
                          {winner.user?.email}
                        </Descriptions.Item>
                        <Descriptions.Item label="Scan Code/QR Code">
                          {winner.user?.coupon_code}
                        </Descriptions.Item>
                        <Descriptions.Item label="Gift">
                          {winner.gift?.label}
                        </Descriptions.Item>
                      </Descriptions>
                    </>
                  );
                })
              ) : (
                <Result
                  status="404"
                  title="No Winners"
                  // subTitle="Sorry, the page you visited does not exist."
                />
              )}
            </Drawer>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Winners;
